var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 155,
    viewBox: "0 0 125 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 144.862,
    y: -5,
    width: 25,
    height: 233.755,
    rx: 12.5,
    transform: "rotate(39.8238 144.862 -5)",
    fill: "#ECA601"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightOrange);
export default __webpack_public_path__ + "static/media/RightOrange.0df338dd6d4c48e6e3eea6cb338cdfdf.svg";
export { ForwardRef as ReactComponent };